import dayjs from 'dayjs';
import { ATTRACTION } from '../../pages/[slug]/[slug2]';

interface TopTip {
  id: string;
  text: string;
  likes: number;
  dislikes: number;
}

interface Top {
  top_tips: TopTip[];
}
interface Iprops {
  attraction?: ATTRACTION;
  top: Top[];
}
const FeaturedNav = ({ attraction, top }: Iprops) => {
  const topTipWithMostLikesAndLeastDislikes = top[0]?.top_tips?.reduce(
    (tipWithMostLikesAndLeastDislikes, tip) => {
      if (
        tipWithMostLikesAndLeastDislikes.likes < tip.likes ||
        (tipWithMostLikesAndLeastDislikes.likes === tip.likes &&
          tipWithMostLikesAndLeastDislikes.dislikes > tip.dislikes)
      ) {
        return tip;
      }
      return tipWithMostLikesAndLeastDislikes;
    },
    top[0]?.top_tips[0]
  );
  return (
    <section>
      <nav className="grid xxsm:grid-cols-2  lg:grid-cols-5  gap-4 py-[12px] xxsm:px-0  lg:px-[10px] lg:border lg:border-t-0 lg:border-solid lg:border-gray-300 lg:shadow-md hover:shadow-lg">
        <div className="flex flex-col items-center border-r-2 lg:border-solid pr-[16px] lg:border-gray-300 col-span-1">
          <span className="text-center text-[#686868] text-[14px] xl:text-[16px] 2xl:text-[20px]">
            Wheel Chair Access
          </span>
          <span
            className={`text-[14px] xl:text-[16px] font-semibold 
             ${
               attraction?.google_data?.wheelchair_accessible_entrance
                 ? 'text-[#4FAC23]'
                 : 'text-[#1F2C5B]'
             }
            `}
          >
            {attraction ? (
              attraction?.google_data?.wheelchair_accessible_entrance ? (
                'Yes'
              ) : (
                'No'
              )
            ) : (
              <div className="h-4 w-32 bg-gray-300 rounded-full animate-pulse"></div>
            )}
          </span>
        </div>
        <div className="xxsm:hidden lg:flex flex-col items-center border-r-2 border-solid pr-[16px] border-gray-300 ">
          <span className="text-[#686868] text-[14px] xl:text-[16px] 2xl:text-[20px]">
            Open Now
          </span>
          <span
            className={`lg:text-[14px] xl:text-[16px] font-semibold
              ${
                attraction?.google_data?.current_opening_hours?.open_now
                  ? 'text-[#4FAC23]'
                  : 'text-[#1F2C5B]'
              }
            `}
          >
            {attraction ? (
              attraction?.google_data?.current_opening_hours?.open_now ? (
                'Open'
              ) : (
                'Closed'
              )
            ) : (
              <div className="h-4 w-32 bg-gray-300 rounded-full animate-pulse"></div>
            )}
          </span>
        </div>
        <div className="flex flex-col items-center lg:border-r-2 border-solid pr-[16px] lg:border-gray-300">
          <span className="text-[#686868] text-[14px] xl:text-[16px] 2xl:text-[20px]">
            Duration
          </span>
          <span
            className={`text-[14px] text-center xl:text-[16px] font-semibold ${
              attraction?.slug ===
              'niagara-falls-tours-canada/Niagara-Helicopters'
                ? 'text-[#4FAC23]'
                : attraction?.google_data?.current_opening_hours?.weekday_text
                ? 'text-[#4FAC23]'
                : 'text-[#1F2C5B]'
            }`}
          >
            {attraction ? (
              attraction?.slug ===
              'niagara-falls-tours-canada/Niagara-Helicopters' ? (
                '12 minutes'
              ) : attraction?.google_data?.current_opening_hours
                  ?.weekday_text ? (
                attraction?.google_data?.current_opening_hours?.weekday_text.filter(
                  item => item.includes(dayjs().format('dddd'))
                )[0] || 'Not Mentioned'
              ) : (
                'Not Mentioned'
              )
            ) : (
              <div className="h-4 w-32 bg-gray-300 rounded-full animate-pulse"></div>
            )}
          </span>
        </div>
        <div className="flex flex-col col-span-2 px-2 lg:px-[16px]">
          <div className="flex flex-row items-center gap-20">
            <div className="lg:text-[14px] xl:text-[16px] 2xl:text-[18px] font-semibold whitespace-nowrap max-w-[20%] ">
              Top Tip
            </div>
            <div>
              {topTipWithMostLikesAndLeastDislikes && (
                <div className="flex justify-end gap-3 items-center max-w-[50%] ">
                  <div className="flex gap-1 items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M19.1395 13.5968C19.5493 13.074 19.7459 12.5136 19.7208 11.9364C19.6957 11.3007 19.4113 10.803 19.1771 10.4977C19.449 9.82016 19.5535 8.75366 18.646 7.92555C17.981 7.31911 16.8517 7.04726 15.2875 7.12254C14.1876 7.17273 13.2674 7.37767 13.2298 7.38603H13.2256C13.0165 7.42367 12.7948 7.46968 12.569 7.51987C12.5523 7.2522 12.5983 6.5872 13.0918 5.08992C13.6773 3.30824 13.6439 1.94479 12.983 1.03304C12.2888 0.0752824 11.1805 0 10.8542 0C10.5406 0 10.252 0.129653 10.047 0.368047C9.5828 0.90757 9.63717 1.90297 9.69572 2.36303C9.14365 3.84358 7.59618 7.47386 6.2871 8.48181C6.26201 8.49854 6.2411 8.51945 6.22019 8.54036C5.83541 8.94605 5.57611 9.38519 5.40045 9.76997C5.15369 9.63614 4.87347 9.56085 4.57234 9.56085H2.02111C1.05917 9.56085 0.28125 10.343 0.28125 11.3007V18.097C0.28125 19.059 1.06335 19.8369 2.02111 19.8369H4.57234C4.94457 19.8369 5.29171 19.7198 5.57611 19.519L6.55896 19.6361C6.70952 19.657 9.38623 19.9958 12.134 19.9414C12.6317 19.9791 13.1002 20 13.5351 20C14.2838 20 14.9362 19.9414 15.4799 19.8243C16.7597 19.5525 17.6338 19.0088 18.0772 18.21C18.4159 17.5993 18.4159 16.9929 18.3616 16.6081C19.1938 15.8553 19.3402 15.023 19.3109 14.4375C19.2942 14.0987 19.2189 13.8101 19.1395 13.5968ZM2.02111 18.7077C1.68234 18.7077 1.41048 18.4316 1.41048 18.097V11.2965C1.41048 10.9578 1.68652 10.6859 2.02111 10.6859H4.57234C4.91111 10.6859 5.18296 10.9619 5.18296 11.2965V18.0928C5.18296 18.4316 4.90693 18.7035 4.57234 18.7035H2.02111V18.7077ZM18.0688 13.1075C17.8931 13.2915 17.8597 13.5717 17.9935 13.7892C17.9935 13.7934 18.165 14.0862 18.1859 14.4877C18.2152 15.0355 17.9517 15.5207 17.3996 15.9348C17.203 16.0853 17.1236 16.3446 17.2072 16.5788C17.2072 16.583 17.3871 17.1351 17.0943 17.6579C16.8141 18.1598 16.1909 18.5194 15.2457 18.7202C14.4887 18.8833 13.4598 18.9126 12.1968 18.8122C12.18 18.8122 12.1591 18.8122 12.1382 18.8122C9.44896 18.8708 6.73043 18.5194 6.70116 18.5153H6.69698L6.27456 18.4651C6.29965 18.348 6.3122 18.2225 6.3122 18.097V11.2965C6.3122 11.1167 6.28292 10.941 6.23273 10.7779C6.30802 10.4977 6.51713 9.87453 7.01065 9.34337C8.88853 7.85445 10.7246 2.83145 10.804 2.61397C10.8375 2.52614 10.8459 2.42995 10.8291 2.33375C10.758 1.86533 10.7831 1.29235 10.8835 1.12087C11.1052 1.12505 11.7032 1.18779 12.0629 1.68549C12.4895 2.2752 12.4728 3.32915 12.0127 4.72606C11.3101 6.85487 11.2516 7.97574 11.8078 8.46926C12.0838 8.71602 12.4519 8.72857 12.7196 8.63237C12.9747 8.57382 13.2173 8.52363 13.4473 8.48599C13.464 8.48181 13.4849 8.47762 13.5017 8.47344C14.7856 8.19322 17.0859 8.02175 17.8848 8.74948C18.5623 9.36846 18.0813 10.1882 18.027 10.276C17.8722 10.5102 17.9182 10.8156 18.1273 11.0038C18.1315 11.0079 18.5707 11.422 18.5916 11.9783C18.6083 12.3505 18.4327 12.7311 18.0688 13.1075Z"
                        fill="black"
                      />
                    </svg>
                    <span className="lg:text-[14px] xl:text-[16px] 2xl:text-[18px]">
                      {topTipWithMostLikesAndLeastDislikes?.likes}
                    </span>
                  </div>
                  <div className="flex gap-1 mt-[5px]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_5807_2457)">
                        <path
                          d="M19.1327 6.40292C19.2121 6.18961 19.2874 5.90101 19.3083 5.5664C19.3376 4.97666 19.1912 4.14851 18.3589 3.39564C18.4133 3.01085 18.4133 2.40019 18.0745 1.79372C17.627 0.990661 16.7528 0.446926 15.4729 0.175058C14.6155 -0.00897493 13.4904 -0.0466181 12.1269 0.0579463C9.37891 0.00357281 6.70206 0.342362 6.55149 0.363275L5.56858 0.480387C5.28417 0.279623 4.93701 0.162511 4.56476 0.162511H2.01339C1.0514 0.162511 0.273438 0.944653 0.273438 1.90246V8.69915C0.273438 9.66115 1.05558 10.4391 2.01339 10.4391H4.56476C4.86591 10.4391 5.14614 10.3638 5.39291 10.23C5.56858 10.6148 5.8279 11.0539 6.2127 11.4597C6.23361 11.4806 6.25452 11.5015 6.27962 11.5182C7.59295 12.5262 9.1405 16.1567 9.68842 17.6373C9.63405 18.0974 9.57967 19.0929 10.0398 19.6324C10.2447 19.8708 10.5291 20.0005 10.847 20.0005C11.1691 20.0005 12.2816 19.9252 12.9759 18.9674C13.6326 18.0556 13.6702 16.6921 13.0847 14.9103C12.5911 13.4129 12.5451 12.7479 12.5618 12.4802C12.7877 12.5304 13.0094 12.5764 13.2227 12.614H13.2269C13.2645 12.6224 14.1847 12.8274 15.2847 12.8775C16.849 12.9528 17.9825 12.681 18.6433 12.0745C19.5551 11.2422 19.4464 10.1798 19.1745 9.50221C19.4087 9.19688 19.6931 8.69915 19.7182 8.0634C19.735 7.4862 19.5426 6.92992 19.1327 6.40292ZM4.56476 9.31399H2.01339C1.6746 9.31399 1.40273 9.03794 1.40273 8.70333V1.90665C1.40273 1.56786 1.67878 1.29599 2.01339 1.29599H4.56476C4.90355 1.29599 5.17542 1.57204 5.17542 1.90665V8.70333C5.17542 9.04212 4.90355 9.31399 4.56476 9.31399ZM18.0201 9.7197C18.0201 9.72388 18.1665 9.95393 18.2167 10.2676C18.2794 10.6566 18.1707 10.9787 17.8779 11.2463C17.079 11.9741 14.7786 11.8068 13.4946 11.5224C13.4778 11.5182 13.4611 11.514 13.4402 11.5098C13.2101 11.468 12.9634 11.4178 12.7124 11.3635C12.4447 11.2673 12.0767 11.2798 11.8006 11.5266C11.2443 12.0201 11.3071 13.1411 12.0056 15.27C12.4657 16.667 12.4824 17.721 12.0558 18.3107C11.6961 18.8084 11.1021 18.8712 10.8763 18.8754C10.7759 18.7081 10.7466 18.135 10.8219 17.6624C10.8344 17.5704 10.8261 17.4742 10.7968 17.3822C10.7173 17.1689 8.88118 12.1414 7.0032 10.6524C6.51384 10.1212 6.30053 9.49802 6.22525 9.21779C6.27544 9.05467 6.30471 8.879 6.30471 8.69915V1.90665C6.30471 1.78117 6.29217 1.65569 6.26707 1.53858L6.68951 1.48839H6.69369C6.71879 1.48421 9.44165 1.13287 12.131 1.19142C12.1478 1.19142 12.1687 1.19142 12.1896 1.19142C13.4569 1.09104 14.4817 1.12032 15.2387 1.28344C16.1756 1.48421 16.7946 1.83554 17.079 2.33327C17.376 2.84773 17.2129 3.37891 17.2003 3.4291C17.1125 3.66333 17.192 3.91847 17.3927 4.06904C18.6308 4.99757 18.0619 6.08086 17.9867 6.2147C17.8486 6.43219 17.8821 6.70824 18.0619 6.89646C18.4216 7.27289 18.5973 7.64932 18.5848 8.01739C18.568 8.56531 18.1456 8.9752 18.1163 9.0003C17.9072 9.18015 17.8695 9.48548 18.0201 9.7197Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_5807_2457">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <span className="lg:text-[14px] xl:text-[16px] 2xl:text-[18px]">
                      {topTipWithMostLikesAndLeastDislikes?.dislikes}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-row lg:text-[14px] xl:text-[16px] 2xl:text-[18px] ">
            {topTipWithMostLikesAndLeastDislikes?.text
              ? topTipWithMostLikesAndLeastDislikes?.text
              : 'No Top Tip Available'}
          </div>
        </div>
      </nav>
    </section>
  );
};

export default FeaturedNav;
